import Query from "@qpr/client-api-base/querybuilder/Query";
import defaultAttributes from "../defaultAttributes";
import { ICardElementWithChildren, IPeriod, IPeriodLevel } from "./model";
import { matchElementPeriodToRequestedPeriod } from "./matchElementPeriodToRequestedPeriod";

export const convertItemListToPeriod = async (
  valuelist: ICardElementWithChildren[],
  period: IPeriod,
  allPeriods: IPeriodLevel[]
) => {
  const list = Promise.all(
    valuelist.map((item) => {
      return matchElementPeriodToRequestedPeriod(
        item.id,
        period.name,
        item.periodlevel
      ).then((reqPeriod) => {
        if (!reqPeriod) {
          return {
            ...item,
            period,
            children: [],
          };
        }
        // return item;
        return Query(item.id)
          .attributes(...defaultAttributes(reqPeriod.name, allPeriods))
          .fetchValues<ICardElementWithChildren>()
          .then((itemlist) => {
            return {
              ...itemlist[0],
              period: reqPeriod,
              children: [],
            };
          });
      });
    })
  );
  return list;
};
